import React from 'react';

const DocumentDetailsSection = ({ 
  formData, 
  isSubmitting, 
  handleChange 
}) => {
  return (
    <>
      <div className="col-span-full mt-4">
        <h3 className="text-black font-semibold mb-4 font-poppins text-lg">
          Document Details
        </h3>
      </div>

      <div className="col-span-full">
        <label className="block text-sm font-medium text-gray-700 mb-2 font-poppins">
          Subject <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          name="subject"
          value={formData.subject}
          onChange={handleChange}
          required
          disabled={isSubmitting}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-poppins"
          placeholder="Enter subject"
        />
      </div>

      <div className="col-span-full">
        <label className="block text-sm font-medium text-gray-700 mb-2 font-poppins">
          Message <span className="text-red-500">*</span>
        </label>
        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
          disabled={isSubmitting}
          rows={4}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-poppins resize-vertical"
          placeholder="Enter your message"
        />
      </div>
    </>
  );
};

export default DocumentDetailsSection; 